import React from 'react';

import EmployerContributions from './components/Employer/employerContributions';
import ShimmerLoader from './components/shimmerLoader';
import { useEmployerFourOhOneKContributionsCurrentYearQuery } from './hooks';

const EmployerFourOhOneKContributions: React.FC<React.PropsWithChildren> = () => {
  const { isLoading, employers } = useEmployerFourOhOneKContributionsCurrentYearQuery();

  return (
    <>
      {isLoading && <ShimmerLoader mt="6" />}
      {!isLoading &&
        !!employers?.length &&
        employers.map(employer => <EmployerContributions employer={employer} key={employer.id} />)}
    </>
  );
};

export default EmployerFourOhOneKContributions;
